import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SiteProvider } from "./context/SiteContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Approach from "./components/Approach";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import Enroll from "./components/Enroll";
import BookingCalendar from "./components/BookingCalendar";
import Booking from "./components/Booking";
import Visit from "./components/Visit";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CrisisBanner from "./components/CrisisBanner";

import AdminLogin from "./admin/AdminLogin";
import AdminEditor from "./admin/AdminEditor";
import AdminDashboard from "./admin/AdminDashboard";
import AdminForgotPassword from "./admin/AdminForgotPassword";
import AdminResetPassword from "./admin/AdminResetPassword";
import Privacy from "./pages/Privacy";
import PaymentSuccess from "./pages/PaymentSuccess";
import Spa from "./pages/Spa";
import Share from "./pages/Share";
import Marketing from "./pages/Marketing";
import MarketingReview from "./pages/MarketingReview";
import MarketingCompare from "./pages/MarketingCompare";
import SocialPlanner from "./pages/SocialPlanner";
import SpaMarketing from "./pages/SpaMarketing";
import VideoScripts from "./pages/VideoScripts";
import Consent from "./pages/Consent";
import ConsentPrint from "./pages/ConsentPrint";
import ReferralForm from "./pages/ReferralForm";
import PrivacyPractices from "./pages/PrivacyPractices";
import Intake from "./pages/Intake";
import CallButton from "./components/CallButton";
import BackgroundMusic from "./components/BackgroundMusic";

const Home = () => (
  <main className="min-h-screen bg-[#FDFBF7] text-[#1C1917] font-sans antialiased overflow-x-hidden">
    <Navbar />
    <Hero />
    <Services />
    <Approach />
    <Team />
    <Testimonials />
    <Enroll />
    <BookingCalendar />
    <Booking />
    <Visit />
    <FAQ />
    <Footer />
    <CrisisBanner />
  </main>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            color: "#1C1917",
            border: "1px solid #E2DCD0",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <SiteProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/spa" element={<Spa />} />
              <Route path="/share" element={<Share />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/marketing/review" element={<MarketingReview />} />
              <Route path="/marketing/compare" element={<MarketingCompare />} />
              <Route path="/socials" element={<SocialPlanner />} />
              <Route path="/marketing/planner" element={<SocialPlanner />} />
              <Route path="/spa/marketing" element={<SpaMarketing />} />
              <Route path="/marketing/spa" element={<SpaMarketing />} />
              <Route path="/video" element={<VideoScripts />} />
              <Route path="/scripts" element={<VideoScripts />} />
              <Route path="/video-scripts" element={<VideoScripts />} />
              <Route path="/consent" element={<Consent />} />
              <Route path="/consent-print" element={<ConsentPrint />} />
              <Route path="/print/consent" element={<ConsentPrint />} />
              <Route path="/referral" element={<ReferralForm />} />
              <Route path="/referrals" element={<ReferralForm />} />
              <Route path="/privacy" element={<PrivacyPractices />} />
              <Route path="/privacy-practices" element={<PrivacyPractices />} />
              <Route path="/intake" element={<Intake />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/forgot" element={<AdminForgotPassword />} />
              <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
              <Route path="/admin/reset" element={<AdminResetPassword />} />
              <Route path="/admin/reset-password" element={<AdminResetPassword />} />
              <Route path="/admin/editor" element={<AdminEditor />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <CallButton />
            <BackgroundMusic />
          </BrowserRouter>
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
